<template>
    <div class="mb-10 md:mb-16">
        <Breadcrumb v-if="breadcrumbItems.length" :items="breadcrumbItems" is-on-page-top />
        <div class="grid grid-cols-12 mt-5 lg:mt-10">
            <div
                class="col-span-12"
                :class="{
                    'md:col-span-10 md:col-start-2': wide,
                    'md:col-start-4 md:col-span-6': narrow,
                    'xl:col-span-8 xl:col-start-3': !narrow,
                }"
            >
                <h1 class="title text-center" :class="subtitle ? 'mb-4 lg:mb-6' : 'mb-0'">
                    {{ title }}
                </h1>
                <h2
                    class="subtitle text-dark-500 text-center"
                    :class="{
                        'text-base text-justify font-HKGrotesk-Regular': smSubtitle,
                    }"
                >
                    {{ subtitle }}
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageIntro',
    props: {
        smSubtitle: {
            type: Boolean,
            required: false,
            default: false,
        },
        wide: {
            type: Boolean,
            required: false,
            default: false,
        },
        narrow: {
            type: Boolean,
            required: false,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
        subtitle: {
            type: String,
            required: false,
            default: null,
        },
        breadcrumbItems: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style scoped></style>
